import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { BiEditAlt } from "react-icons/bi";
import { Modal, Button } from "react-bootstrap";
import "./hm-theme.css";

function LabAdminLink({ selectedOrgcode }) {
  const [adminLink, setAdminLink] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [labs, setLabs] = useState(null);
  const [loading, setLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);

  const getData = async () => {
    const token = JSON.parse(localStorage.getItem("data"))?.token;
    try {
      const response = await axios.get(`/api/labdetails/labcode=${selectedOrgcode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAdminLink(response.data);
    } catch (error) {
      handleError(error);
    }
  };

  const fetchAccounts = async () => {
    const token = JSON.parse(localStorage.getItem("data"))?.token;
    try {
      const response = await axios.get(`/api/accounts/role=ROLE_ADMIN`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAccounts(response.data || []);
    } catch (error) {
      handleError(error);
    }
  };

  const navigate = useNavigate();
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleEditLocation = (adminLinkData) => {
    setLabs(adminLinkData);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data"))?.token;

    try {
      await axios.post('/api/labdetails/update',
        {
          id: labs.id,
          adminlink: labs.adminEmail 
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      toast.success("Admin Link updated successfully");
      handleCloseModal();
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  useEffect(() => {
    getData();
    fetchAccounts();
  }, [selectedOrgcode]);

  return (
    <div>
      {loading && <div className="loading"></div>}

      <div className="hm-card">
        {/* Header */}
        <div className="hm-card-header">
          <h3 className="hm-card-title">
            <i className="material-icons">admin_panel_settings</i>
            Admin Link
          </h3>
        </div>

        {/* Table */}
        <div className="hm-card-body p-0">
          <div style={{ overflowX: "auto" }}>
            <table className="hm-table">
              <thead>
                <tr>
                  <th>Admin Email</th>
                  <th style={{ width: "80px" }}>Edit</th>
                </tr>
              </thead>
              <tbody>
                {!adminLink?.adminEmail ? (
                  <tr>
                    <td colSpan="2">
                      <div className="hm-empty-state">
                        <i className="material-icons">link_off</i>
                        <p>No Admin Link Configured</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr key={adminLink?.id}>
                    <td className="fw-medium text-dark">{adminLink?.adminEmail}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-outline-warning btn-sm rounded-circle p-1 d-inline-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px" }}
                        title="Edit Admin Link"
                        onClick={() => handleEditLocation(adminLink)}
                      >
                        <BiEditAlt size={16} />
                      </button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <Modal show={isModalOpen} onHide={handleCloseModal} centered className="hm-modal">
          <Modal.Header closeButton className="hm-card-header">
            <Modal.Title className="hm-card-title">
              <i className="material-icons">link</i>
              Update Admin Link
            </Modal.Title>
          </Modal.Header>
          <form onSubmit={handleSubmit}>
            <Modal.Body className="p-4">
              <div className="mb-3">
                <label htmlFor="emailSelect" className="form-label small fw-semibold">Select Admin Email:</label>
                <select
                  id="emailSelect"
                  className="form-select"
                  value={labs?.adminEmail || ""}
                  onChange={(e) => setLabs({ ...labs, adminEmail: e.target.value })}
                  required
                >
                  <option value="">Select an email...</option>
                  {accounts.map((account) => (
                    <option key={account.id} value={account.id}>
                      {account.username}
                    </option>
                  ))}
                </select>
              </div>
            </Modal.Body>
            <Modal.Footer className="border-0 pt-0 pb-4 px-4 d-flex justify-content-end gap-2">
              <Button variant="secondary" className="rounded-pill px-4" onClick={handleCloseModal}>
                Cancel
              </Button>
              <button
                type="submit"
                className="btn-hm-primary"
                disabled={loading || !labs?.adminEmail}
              >
                Save Changes
              </button>
            </Modal.Footer>
          </form>
        </Modal>
      )}
    </div>
  );
}

export default LabAdminLink;

